import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import EzControlledDropDowntWithFloatingLabel from "../../../../common/EzForm/EzControlledDropDown/WithFloatingLabel";
import "./styles.css";
import { goBack } from "../../../../utils/gotoback";
import { loadingShow } from "../../../../services/PostAPI";
import Breadcrumb from "../../../../common/Breadcrumb";
import { useStyles } from "../style";
import {
  basicDetail,
  datagetbyid,
  driverageDD,
  editMode,
  statusDD,
  typeDD,
} from "../CreateReservationsPrepaidBookingsReport/constant";
import { Box, Container, Grid, Typography } from "@mui/material";
import EzControlledInputWithFloatingLabel from "../../../../common/EzForm/EzControlledInput/WithFloatingLabel";
import { EzToast, TOAST_SEVERITY } from "../../../../common/EzToast";
import { useNavigate, useParams } from "react-router-dom";
import { APP_URLS } from "../../../../utils/constant";
import EzControlledCalendarWithFloatingLabel from "../../../../common/EzForm/EzControlledCalendar/WithFloatingLabel";
import { getFormBaseValidationRule } from "../../../../utils/form/form-utils";
import EzControlledCheckBoxWithLabel from "../../../../common/EzForm/EzControlledCheckBox/WithLabel";
import { hourslist } from "../../../Location/CreateLocation/constant";
import EzControlledInputAreaWithFloatingLabel from "../../../../common/EzForm/EzControlledInputArea/WithFloatingLabel";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import HeatPumpIcon from "@mui/icons-material/HeatPump";
import SpeedIcon from "@mui/icons-material/Speed";
import CardICON from "../../../../images/car-door.png";
import { ReservationsReservationsBreadcrumb } from "../../ReservationsReservations/CreateReservationsReservations/constant";
import {
  cancelResonsDD,
  paymentStatusDD,
} from "../../../Renters/RentersRegisteredRenters/CreateRentersRegisteredRenters/constant";
const CreateReservationsPrepaidBookingsReportComponent = (props) => {
  const navigate = useNavigate();
  const {
    history,
    initCreateReservationsPrepaidBookingsReportScreen,
    createReservationsPrepaidBookingsReport,
    editReservationsPrepaidBookingsReport,
    isLoading,
    isReservationsPrepaidBookingsReportCreateSuccess,
    isReservationsPrepaidBookingsReportCreateError,
    isReservationsPrepaidBookingsReportDetailSuccess,
    isReservationsPrepaidBookingsReportDetailError,
    isReservationsPrepaidBookingsReportEditSuccess,
    isEdit,
    isView,
    formFieldValueMap,
    shouldBlockNavigation,
    uploadImage,
    imageUploadResponse,
    isUploadImageSuccess,
    isUploadImageError,
    vehicleModelDD,
    isVehicleModelDDSuccess,
    isVehicleModelDDError,
    locationDD,
    vehicleCategoryDD,
    updateCancellationStatus,
    updatePaymentStatus,
    isUpdateCancellationStatusSuccess,
    isUpdateCancellationStatusError,
    isUpdatePaymentStatusSuccess,
    isUpdatePaymentStatusError,
  } = props;

  const classes = useStyles();

  const {
    control,
    formState: { errors, isDirty },
    watch,
    register,
    handleSubmit,
    reset,
  } = useForm({
    defaultValues: useMemo(() => {
      return formFieldValueMap;
    }, [formFieldValueMap]),
  });
  const cancellation = watch("reasonCancel");
  const otherreson = watch("reasonOtherDetails");

const navigateToReservationsPrepaidBookingsReportScreen = () => {
  navigate(APP_URLS.RESERVATIONS_PREPAIDBOOKINGSREPORT.HOME, {
    state: { fromDetail: true } // Add flag to navigation state
  });
};

  const [inclusiveRate, setInclusiveRate] = useState(false);
  const handleCheckbox = (e) => {
    const { name, checked } = e.target;
    setInclusiveRate(checked);
  };
  const Base64Image = ({ base64String }) => {
    return (
      <div>
        <img
          src={base64String}
          alt="Base64 Image"
          style={{ width: "100%", height: "auto" }}
        />
      </div>
    );
  };
  useEffect(() => {
    if (
      isReservationsPrepaidBookingsReportCreateSuccess ||
      isReservationsPrepaidBookingsReportEditSuccess
    ) {
      reset();
    }
  }, [isReservationsPrepaidBookingsReportCreateSuccess]);
  useEffect(() => {
    if (isReservationsPrepaidBookingsReportDetailSuccess) {
      reset({
        ...formFieldValueMap,
        reasonCancel: parseInt(formFieldValueMap.reasonCancel),
      });
    }
  }, [isReservationsPrepaidBookingsReportDetailSuccess]);
  useEffect(() => {
    initCreateReservationsPrepaidBookingsReportScreen();
  }, []);

  const handleCancel = () => {
    const stringifiedData = {
      reasonOtherDetails: otherreson,
      reasonCancel: cancellation,
      reservationId: id,
    };
    updateCancellationStatus(stringifiedData);
  };

  // const onSubmit = (data) => {
  //   let newData = data;
  //   newData["userId"] = localStorage.getItem("userId");

  //   const stringifiedData = {
  //     ...newData,
  //   }

  //   isEdit
  //     ? editReservationsPrepaidBookingsReport({ id: data.id, data: stringifiedData })
  //     : createReservationsPrepaidBookingsReport(stringifiedData);

  // };

  const { id } = useParams();
  const onSubmit = (data) => {
    let newData = data;
    newData["userId"] = localStorage.getItem("userId");

    const stringifiedData = {
      note: data?.note,
      paymentStatus: data?.paymentStatus,
      reservationId: id,
    };

    isEdit
      ? updatePaymentStatus(stringifiedData)
      : updatePaymentStatus(stringifiedData);
  };
  const getToastProps = () => {
    const toastTitle = "Please select category from list";
    return {
      severity: TOAST_SEVERITY.ERROR,
      toastTitle,
      shouldShowToast: false,
    };
  };

  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  const renderPageHeaderSection = () => {
    return (
      <div className="make-relative sub-header ">
        <div className="maintitlediv">
          <div className="ml-3">
            <h4 className="pagetitle">Prepaid Bookings Report</h4>
          </div>
          <div className="buttonarea">
            <Button
              tooltip={"Back to Prepaid Bookings Report"}
              tooltipOptions={{ position: "left" }}
              label={"Back to Prepaid Bookings Report"}
              // icon={"pi pi-arrow-left"}
              className={`p-button `}
              style={{ borderRadius: "10px" }}
              onClick={navigateToReservationsPrepaidBookingsReportScreen}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <Container maxWidth="lg">
      <Breadcrumb list={ReservationsReservationsBreadcrumb} />
      <EzToast {...getToastProps()} />
      <div className={`containerbox ${classes.bg}`}>
        {renderPageHeaderSection()}
        <div className="form-demo">
          <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
            <Typography variant="h3" marginLeft={"5px"} marginTop={"5px"}>
              {formFieldValueMap?.title}
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={8}>
                <Typography className="headbgblue" variant="h6">
                  Selected Vehicle Information
                  <span>Confirmed</span>
                </Typography>

                <Grid container spacing={2}>
                  <Grid item xs={5}>
                    <Box>
                      <Base64Image
                        base64String={
                          formFieldValueMap?.renterVehicleInfo?.imgUrl
                        }
                      />
                    </Box>
                    <p className="vantype">Mini-Vans</p>
                    <Box className="vandetails">
                      <ul>
                        <li>
                          <Diversity3Icon />
                          <span>
                            {formFieldValueMap?.renterVehicleInfo?.passenger}
                          </span>
                        </li>
                        <li>
                          <BusinessCenterIcon />
                          <span>
                            {formFieldValueMap?.renterVehicleInfo?.luggage}
                          </span>
                        </li>
                        <li>
                          <ManageAccountsIcon />
                          <span>
                            {formFieldValueMap?.renterVehicleInfo?.transmission}
                          </span>
                        </li>
                        <li>
                          <img src={CardICON} />
                          <span>
                            {formFieldValueMap?.renterVehicleInfo?.doors}
                          </span>
                        </li>
                        <li>
                          <HeatPumpIcon />
                          <span>
                            {formFieldValueMap?.renterVehicleInfo?.ac}
                          </span>
                        </li>
                        <li>
                          <SpeedIcon />
                          <span>
                            {formFieldValueMap?.renterVehicleInfo?.passenger}
                          </span>
                        </li>
                      </ul>
                    </Box>
                    <Grid item xs={12} marginTop={"30px"}>
                      <Button type="button" className="text-center">
                        Send confirmation Email
                      </Button>
                    </Grid>

                    <Grid item xs={12} marginTop={"30px"}>
                      <EzControlledDropDowntWithFloatingLabel
                        name="paymentStatus"
                        control={control}
                        rules={
                          getFormBaseValidationRule().DEFAULT.DO_NOT_VALIDATE
                        }
                        optionLabel={"name"}
                        optionValue={"id"}
                        options={paymentStatusDD}
                        isError={errors["paymentStatus"]}
                        errorMsg={getFormErrorMessage("paymentStatus")}
                        label="Payment Status"
                        labelClassName={"ml-2"}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <EzControlledInputAreaWithFloatingLabel
                        name="note"
                        control={control}
                        label="Additional Notes"
                        type="text"
                        rules={
                          getFormBaseValidationRule().DEFAULT.DO_NOT_VALIDATE
                        }
                        isError={errors["note"]}
                        errorMsg={getFormErrorMessage("note")}
                      />
                    </Grid>

                    <div className={"make-flex mt-3 mr-2"}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "end",
                        }}
                      >
                        <React.Fragment>
                          <div
                            style={{
                              margin: "15px 0px 15px 10px",
                              minWidth: "100px",
                            }}
                          >
                            <Button
                              type="submit"
                              label={isEdit ? "Update" : "Save"}
                              className="mt-2 p-button-raised"
                            />
                          </div>
                        </React.Fragment>
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={7} className="boxmidright">
                    <Typography variant="h6" className="sub">
                      Total Amount
                      <span>
                        ${" "}
                        {formFieldValueMap?.renterAmountDetails?.totalAmount ??
                          0}
                      </span>
                    </Typography>

                    <table className="tbleforRenter">
                      <tbody>
                        <tr className="rowfont">
                          <td colSpan={2}>Before Taxes</td>
                          <td className="textr">
                            ${" "}
                            {formFieldValueMap?.renterAmountDetails?.baseRate ??
                              0}
                          </td>
                        </tr>
                        <tr className="rowfont">
                          <td colSpan={3}>
                            {formFieldValueMap?.renterAmountDetails?.daysString}
                          </td>
                        </tr>
                        <tr className="rowfont">
                          <td colSpan={2}>Extras </td>
                          <td className="textr">
                            ${" "}
                            {formFieldValueMap?.renterAmountDetails
                              ?.extraAmount ?? 0}
                          </td>
                        </tr>

                        <tr className="rowfont2">
                          <td>Damage Protection Plans</td>
                          <td>
                            {
                              formFieldValueMap?.renterAmountDetails?.damagePro
                                ?.title
                            }{" "}
                          </td>
                          <td className="textr">
                            ${" "}
                            {formFieldValueMap?.renterAmountDetails?.damagePro
                              ?.amount ?? 0}{" "}
                          </td>
                        </tr>
                        <tr className="rowfont2">
                          <td>Glass & Tire</td>
                          <td>
                            {
                              formFieldValueMap?.renterAmountDetails
                                ?.extrasGlassDetails?.title
                            }{" "}
                          </td>
                          <td className="textr">
                            ${" "}
                            {formFieldValueMap?.renterAmountDetails
                              ?.extrasGlassDetails?.amount ?? 0}{" "}
                          </td>
                        </tr>
                        <tr className="rowfont2">
                          <td>Equipment</td>
                          <td>
                            {
                              formFieldValueMap?.renterAmountDetails
                                ?.equipmentDetails?.title
                            }{" "}
                          </td>
                          <td className="textr">
                            ${" "}
                            {formFieldValueMap?.renterAmountDetails
                              ?.equipmentDetails?.amount ?? 0}{" "}
                          </td>
                        </tr>
                        <tr className="rowfont2">
                          <td>Out of Province</td>
                          <td>
                            {
                              formFieldValueMap?.renterAmountDetails
                                ?.outOfProvinceDetails?.title
                            }{" "}
                          </td>
                          <td className="textr">
                            ${" "}
                            {formFieldValueMap?.renterAmountDetails
                              ?.outOfProvinceDetails?.amount ?? 0}
                          </td>
                        </tr>
                        <tr className="rowfont2">
                          <td>Extra Mileage</td>
                          <td>
                            {
                              formFieldValueMap?.renterAmountDetails
                                ?.extraMileageDetails?.title
                            }{" "}
                          </td>
                          <td className="textr">
                            ${" "}
                            {formFieldValueMap?.renterAmountDetails
                              ?.extraMileageDetails?.amount ?? 0}{" "}
                          </td>
                        </tr>
                        <tr className="rowfont">
                          <td colSpan={2}>Fees</td>
                          <td className="textr">
                            ${" "}
                            {formFieldValueMap?.renterAmountDetails?.fees ?? 0}
                          </td>
                        </tr>

                        <tr className="rowfont">
                          <td colSpan={2}>Underage Driver Fees</td>
                          <td className="textr">
                            ${" "}
                            {formFieldValueMap?.renterAmountDetails
                              ?.underageDriverFee ?? 0}
                          </td>
                        </tr>
                        <tr className="rowfont">
                          <td colSpan={2}>
                            Airport Facility Charge Total for 3
                          </td>
                          <td className="textr">
                            ${" "}
                            {formFieldValueMap?.renterAmountDetails
                              ?.airportSurcharge ?? 0}
                          </td>
                        </tr>
                        <tr className="rowfont">
                          <td colSpan={2}>Concession Fee</td>
                          <td className="textr">
                            ${" "}
                            {formFieldValueMap?.renterAmountDetails
                              ?.airportConcession ?? 0}
                          </td>
                        </tr>
                        <tr className="rowfont">
                          <td colSpan={2}>After Hour Fee</td>
                          <td className="textr">
                            ${" "}
                            {formFieldValueMap?.renterAmountDetails
                              ?.afterHourFee ?? 0}
                          </td>
                        </tr>
                        <tr className="rowfont">
                          <td colSpan={2}>Estimated Taxes</td>
                          <td className="textr">
                            $ {formFieldValueMap?.renterAmountDetails?.tax ?? 0}
                          </td>
                        </tr>
                        <tr className="rowfont">
                          <td colSpan={2}>Total amount of your booking</td>
                          <td className="textr">
                            ${" "}
                            {formFieldValueMap?.renterAmountDetails
                              ?.totalAmount ?? 0}
                          </td>
                        </tr>
                        <tr className="rowfont blue">
                          <td colSpan={2}>Total without extras</td>
                          <td className="textr">
                            ${" "}
                            {formFieldValueMap?.renterAmountDetails
                              ?.totalAmount ?? 0}
                          </td>
                        </tr>
                        <tr className="rowfont">
                          <td colSpan={2}>Pay on arrival</td>
                          <td className="textr">
                            ${" "}
                            {formFieldValueMap?.renterAmountDetails
                              ?.extraAmount ?? 0}
                          </td>
                        </tr>
                        <tr className="rowfont red">
                          <td colSpan={2}>Limited Kilometers</td>
                          <td className="textr">
                            {
                              formFieldValueMap?.renterAmountDetails
                                ?.limitedKilometers
                            }
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={4}>
                <Typography className="headbgblue" variant="h6">
                  Driver Information
                </Typography>
                <table className="tbleforRenter">
                  <tbody>
                    <tr className="rowfont">
                      <td>
                        <b>Name:</b>
                      </td>
                      <td className="textl">
                        {formFieldValueMap?.driverInfo?.name}
                      </td>
                    </tr>
                    <tr className="rowfont">
                      <td>
                        <b>Email ID:</b>
                      </td>
                      <td className="textl">
                        {formFieldValueMap?.driverInfo?.emailId}
                      </td>
                    </tr>
                    <tr className="rowfont">
                      <td>
                        <b>Contact:</b>
                      </td>
                      <td className="textl">
                        {formFieldValueMap?.driverInfo?.contact}
                      </td>
                    </tr>
                    <tr className="rowfont">
                      <td>
                        <b>Address:</b>
                      </td>
                      <td className="textl">
                        {formFieldValueMap?.driverInfo?.address}
                      </td>
                    </tr>
                    <tr className="rowfont">
                      <td>
                        <b>Flight/Special:</b>
                      </td>
                      <td className="textl">
                        {formFieldValueMap?.driverInfo?.flight}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <Typography className="headbgblue" variant="h6">
                  Itinerary
                </Typography>

                <table className="tbleforRenter">
                  <tbody>
                    <tr className="rowfont">
                      <td>
                        <b>Pickup</b>
                      </td>
                      <td className="textl">
                        <b>Dropoff</b>
                      </td>
                    </tr>
                    <tr className="rowfont">
                      <td className="textl">
                        {formFieldValueMap?.itinerary?.pickup}
                      </td>
                      <td className="textl">
                        {formFieldValueMap?.itinerary?.dropoff}
                      </td>
                    </tr>
                    <tr className="rowfont">
                      <td colSpan={2}>
                        {" "}
                        <b>Pickup & Dropoff Location</b>
                      </td>
                    </tr>
                    <tr className="rowfont">
                      <td colSpan={2} className="textl">
                        {formFieldValueMap?.itinerary?.location}
                      </td>
                    </tr>
                    <tr className="rowfont">
                      <td colSpan={2} className="textl">
                        <a href="#">Google Map Link</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <Typography className="headbgblue" variant="h6">
                  Cancellation
                </Typography>
                <Grid item xs={12} marginTop={"30px"}>
                  <EzControlledDropDowntWithFloatingLabel
                    name="reasonCancel"
                    control={control}
                    rules={getFormBaseValidationRule().DEFAULT.DO_NOT_VALIDATE}
                    optionLabel={"name"}
                    optionValue={"id"}
                    options={cancelResonsDD}
                    isError={errors["reasonCancel"]}
                    errorMsg={getFormErrorMessage("reasonCancel")}
                    label="Reason for Cancellation"
                    labelClassName={"ml-2"}
                  />
                </Grid>
                {cancellation == "6" && (
                  <Grid item xs={12}>
                    <EzControlledInputAreaWithFloatingLabel
                      name="reasonOtherDetails"
                      control={control}
                      label="Others"
                      type="text"
                      rules={
                        getFormBaseValidationRule().DEFAULT.DO_NOT_VALIDATE
                      }
                      isError={errors["reasonOtherDetails"]}
                      errorMsg={getFormErrorMessage("reasonOtherDetails")}
                    />
                  </Grid>
                )}
                <React.Fragment>
                  <div
                    style={{ margin: "0px 0px 15px 0px", maxWidth: "100px" }}
                  >
                    <Button
                      type="button"
                      label={"Cancel"}
                      severity="danger"
                      onClick={handleCancel}
                      className="mt-2 p-button-raised danger"
                    />
                  </div>
                </React.Fragment>
              </Grid>
            </Grid>

            {isEdit && (
              <Grid className="modsection" container spacing={2}>
                {editMode?.map((item) => (
                  <Grid item xs={3} key={item.name}>
                    <EzControlledInputWithFloatingLabel
                      name={item?.name}
                      control={control}
                      disabled={item?.disabled}
                      label={item?.label}
                      type={item?.type}
                      rules={item?.rule}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                    />
                  </Grid>
                ))}
              </Grid>
            )}
          </form>
        </div>
      </div>
    </Container>
  );
};

export default CreateReservationsPrepaidBookingsReportComponent;
